const falsyValues = ['', 0, false]

export const compareFFItems = (a: unknown, b: unknown) => {
  if (Object.is(a, b)) {
    return true
  }

  const aEmptyArray = !a || (Array.isArray(a) && a.length === 0)
  const bEmptyArray = !b || (Array.isArray(b) && b.length === 0)

  if (aEmptyArray && bEmptyArray) {
    return true
  }

  const bSorted = (Array.isArray(b) ? b : []).slice().sort()
  const equalArrays =
    Array.isArray(a) &&
    Array.isArray(bSorted) &&
    a.length === bSorted.length &&
    a
      .slice()
      .sort()
      .every((value, index) => value === bSorted[index])

  if (equalArrays) {
    return true
  }

  const aFalsy = !a || falsyValues.find((elem) => elem === a)
  const bFalsy = !b || falsyValues.find((elem) => elem === b)

  if (aFalsy && bFalsy) {
    return true
  }

  return false
}

const featureFlagsItemDiff = (
  preset: Record<string, unknown>,
  override: Record<string, unknown>,
) => {
  if (compareFFItems(preset, override)) {
    return undefined
  }

  if (!override || typeof override !== 'object') {
    return override
  }

  if (Array.isArray(override)) {
    const arrayToCompare: unknown[] = Array.isArray(preset) ? preset : []
    const arrayDiff = override.filter((el) => !arrayToCompare.includes(el))

    return arrayDiff.length ? arrayDiff : undefined
  }

  return featureFlagsObjectDiff(preset, override)
}

const featureFlagsObjectDiff = (
  preset: Record<string, unknown>,
  override: Record<string, unknown>,
) => {
  const result: Record<string, unknown> = {}

  Object.keys(override).forEach((key) => {
    const value = featureFlagsItemDiff(
      preset?.[key] as Record<string, unknown>,
      override[key] as Record<string, unknown>,
    )

    if (
      value !== undefined &&
      (typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length > 0)
    ) {
      result[key] = value
    }
  })

  return result
}

export const featureFlagsDiff = (
  preset: Record<string, unknown>,
  override: Record<string, unknown>,
) => featureFlagsObjectDiff(preset, override || {})
